import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import ListIngressos from './pages/ListIngressos';
import MeusIngressos from './pages/MeusIngressos';
import IngressoPage from './pages/IngressoPage';
import PedidoPage from './pages/PedidoPage';

function App() {
  return (
    <Router>
      <Switch>
        <Route exact path="/" component={LandingPage} />
        <Route path="/listIngressos" component={ListIngressos} />
        <Route path="/admin" component={ListIngressos} />
        <Route path="/meus-ingressos" component={MeusIngressos} />
        <Route path="/ingresso/:ticketNumber" component={IngressoPage} />
        <Route path="/pedido/:paymentId" component={PedidoPage} />
      </Switch>
    </Router>
  );
}

export default App;